import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

const base = 'test'

AdminRouter.addRoute({
  name: `partner.test1`,
  path: `/builder`,
  component: () => import('./Test1.vue'),
  meta: {
    auth: true,
  },
})
AdminRouter.addRoute({
  name: `partner.test2`,
  path: `/domain`,
  component: () => import('./Test2.vue'),
  meta: {
    auth: true,
  },
})
AdminRouter.addRoute({
  name: `partner.test3`,
  path: `/expert`,
  component: () => import('./Test3.vue'),
  meta: {
    auth: true,
  },
})

//AdminSidebar.pushItem({
//  id: `${base}`,
//  order: 90,
//  header: $vm => $vm.$t(`partners.tools1_title`),
//  text: $vm => $vm.$t(`partners.tools2_title`),
//  icon: 'icon-cog',
//  permission: $vm => {
//    return ($vm.$account && $vm.$account.partner) || ($vm.$account && $vm.$account.company)
//  },
//  children: [
//    {
//      id: 'test.partner.test1',
//      order: 30,
//      text: $vm => $vm.$t(`partners.builder_title`),
//      route: {
//        name: `partner.test1`,
//      },
//      icon: 'icon-percent',
//    },
//    // {
//    //   id: 'test.partner.test2',
//    //   order: 30,
//    //   text: $vm => $vm.$t(`partners.domain_title`),
//    //   route: {
//    //     name: `partner.test2`,
//    //   },
//    //   icon: 'icon-coins',
//    // },
//    {
//      id: 'test.partner.test3',
//      text: $vm => $vm.$t('partners.expert_title'),
//      icon: 'icon-airplane2',
//      route: {
//        name: 'partner.test3',
//      },
//    },
//  ],
//})

messageGroups.push('partners')
